import { memo } from "react";

const Banner = () => {
  return (
    <div className="bg-banner-mobile mb:bg-banner bg-cover pb-165% mb:pb-54%"></div>
  );
};

export default memo(Banner);
